import Api from "@src/api";
export const InstallLocationMasterApi= {
  getTree(params) {
    return Api().get("InstallLocation/getAll",{params});
  },
  getInstallLocationById(id) {
    return Api().get("InstallLocation/" + id);
  },
  updateInstallLocation(data) {
    return Api().put("InstallLocation", data);
  },
  createInstallLocation(data) {
    return Api().post("InstallLocation", data);
  },
  deleteInstallLocation(id) {
    return Api().delete("InstallLocation/" + id);
  },
};
